function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.5,
  cy: 40.5,
  r: 40.5,
  fill: "#141414"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M41 50.1666C43.0167 50.1666 44.6667 48.5166 44.6667 46.4999C44.6667 44.4833 43.0167 42.8333 41 42.8333C38.9833 42.8333 37.3333 44.4833 37.3333 46.4999C37.3333 48.5166 38.9833 50.1666 41 50.1666ZM52 33.6666H50.1667V29.9999C50.1667 24.9399 46.06 20.8333 41 20.8333C35.94 20.8333 31.8333 24.9399 31.8333 29.9999H35.3167C35.3167 26.8649 37.865 24.3166 41 24.3166C44.135 24.3166 46.6833 26.8649 46.6833 29.9999V33.6666H30C27.9833 33.6666 26.3333 35.3166 26.3333 37.3333V55.6666C26.3333 57.6833 27.9833 59.3333 30 59.3333H52C54.0167 59.3333 55.6667 57.6833 55.6667 55.6666V37.3333C55.6667 35.3166 54.0167 33.6666 52 33.6666ZM52 55.6666H30V37.3333H52V55.6666Z",
  fill: "white"
});

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2245ec16.svg";
export { ForwardRef as ReactComponent };